<template>
  <table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%">
    <tr>
      <th :width="w1" class="stack-column-center align-top">
        <table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%">
          <tr>
            <td dir="ltr" valign="top" style="padding: 10px 0 0 20px;">
              <a v-if="block.image_cta_url" :href="block.image_cta_url" target="_blank" style="text-decoration: none;">
                <img :src="block.image_url || `/img/frontend/blocks/${iw}.png`" :width="iw" :height="iw" :alt="block.image_alt || ''" border="0" class="center-on-narrow" style="height: auto; background: #dddddd; font-size: 15px; line-height: 15px; color: #555555;">
              </a>
              <img v-if="!block.image_cta_url" :src="block.image_url || `/img/frontend/blocks/${iw}.png`" :width="iw" :height="iw" :alt="block.image_alt || ''" border="0" class="center-on-narrow" style="height: auto; background: #dddddd; font-size: 15px; line-height: 15px; color: #555555;">
            </td>
          </tr>
        </table>
      </th>
      <th :width="w2" class="stack-column-center">
        <table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%">
          <tr>
            <td dir="ltr" valign="top" style="font-size: 15px; line-height: 20px; color: #555555; padding: 10px 20px; text-align: left;" class="center-on-narrow">
              <div v-if="block.text" v-html="replacePlaceholders(block.text, placeholders)" class="first-child-no-top-margin"></div>
              <table v-if="block.button_text && block.button_url" role="presentation" cellspacing="0" cellpadding="0" border="0" class="center-on-narrow" style="float:left;">
                <tr>
                  <td class="button-td button-td-primary" :style="`padding-bottom: 10px; border-radius: ${button_radius !== null ? button_radius : 4}px;`">
								    <a class="button-a button-a-primary" :href="block.button_url" :style="`background: ${button_color}; border: 1px solid ${button_color}; font-size: 15px; line-height: 15px; text-decoration: none; padding: 13px 17px; color: ${buttonTextColor}; display: block; border-radius: ${button_radius !== null ? button_radius : 4}px;`" target="_blank">{{ block.button_text }}</a>
								  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </th>
    </tr>
  </table>
</template>
<script>
  export default {
    props: {
      block: Object,
      button_color: String,
      button_radius: Number,
      placeholders: Object,
    },
    computed: {
      w1() {
        return this.block.image_percent === 0.5 ? '50%' : '33.33%'
      },
      w2() {
        return this.block.image_percent === 0.5 ? '50%' : '66.66%'
      },
      iw() {
        return this.block.image_percent === 0.5 ? 270 : 170
      },
      buttonTextColor() {
        return _.hexContrastColor(this.button_color)
      },
    },
    methods: {
      replacePlaceholders: _.replacePlaceholders,
    },
  }
</script>